import React, { FC, useState } from 'react'
import { SelectProps as AntSelectProps } from 'antd/lib/select'
import { Select as AntSelect } from 'antd'
import { Icon } from '@iconify/react'

import { Tag, Button, Input } from '../../atoms'

import styles from './_.module.css'

interface Props extends AntSelectProps<string> {
  addItem: (value: { width: string; height: string }) => void
}

export const DimensionsSelect: FC<Props> = ({
  mode,
  bordered,
  className,
  defaultValue,
  disabled,
  maxTagCount,
  onBlur,
  onChange,
  placeholder,
  optionFilterProp,
  options,
  size,
  value,
  addItem
}) => {
  const [dimensions, setDimensions] = useState({ width: '', height: '' })

  const tagRender = (props: any) => {
    const { label, closable, onClose } = props

    // if the tag is closable means that it is the maxCount placeholder
    if (!closable) {
      return <span className={styles.maxPlaceholder}>{label}</span>
    }

    return (
      <Tag className={styles.selectTag} closable={closable} onClose={onClose}>
        <span className={styles.selectTagLabel}>{label}</span>
      </Tag>
    )
  }

  return (
    <div>
      <AntSelect
        mode={mode}
        tagRender={tagRender}
        dropdownRender={menu => (
          <div>
            {menu}

            <div className={styles.addOptions}>
              <Input
                className={styles.selectInput}
                value={dimensions.width}
                placeholder="Width"
                size="middle"
                onChange={e =>
                  setDimensions({
                    width: e.target.value,
                    height: dimensions.height
                  })
                }
              />
              <div className={styles.operator}>X</div>
              <Input
                className={styles.selectInput}
                value={dimensions.height}
                placeholder="Height"
                size="middle"
                onChange={e =>
                  setDimensions({
                    width: dimensions.width,
                    height: e.target.value
                  })
                }
              />
              <div className={styles.operator}>px</div>
              <Button
                className={styles.addBtn}
                icon={<Icon icon="ant-design:plus-outlined" />}
                disabled={!dimensions.width || !dimensions.height}
                type="link"
                onClick={() => {
                  addItem(dimensions)
                  setDimensions({ width: '', height: '' })
                }}
              >
                Add Custom
              </Button>
            </div>
          </div>
        )}
        className={className}
        bordered={bordered}
        defaultValue={defaultValue}
        disabled={disabled}
        onBlur={onBlur}
        options={options}
        optionFilterProp={optionFilterProp}
        placeholder={placeholder}
        optionLabelProp="label"
        size={size}
        maxTagCount={maxTagCount}
        maxTagPlaceholder={item => {
          return `+${item.length}`
        }}
        value={value}
        onChange={onChange}
      >
        {options?.map(option => (
          <AntSelect.Option
            value={option.value}
            label={option.label}
            key={option.value}
          >
            {option.label}
          </AntSelect.Option>
        ))}
      </AntSelect>
    </div>
  )
}
